export const planLimitReached = ({ total = 0, limit = -1 } = {}) => limit > -1 && total >= limit;
